import { render, staticRenderFns } from "./PeugeotDetails.vue?vue&type=template&id=70380341&scoped=true&"
import script from "./PeugeotDetails.vue?vue&type=script&lang=js&"
export * from "./PeugeotDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70380341",
  null
  
)

export default component.exports